/* eslint-disable array-callback-return */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import TableGridWithFeatures from '../../../../../SharedModules/Table/TableGridWithFeatures';
import { tableHead } from './gridComponents/tableHead';
import {
  dispatchNMFinCodes,
  dispatchValidateNmFinCd,
  getNMFinCode,
  setNMAccInSys,
  validateNmFinCd,
} from '../../store/actions';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import SaveCancelPopup from '../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import DeleteActionRender from '../deleteActionRender';
import TextBoxRender from './gridComponents/TextBoxRender';
import { DELETE_NM_ERR } from '../../../../../SharedModules/Errors/constantMessageData';
import { tableGridHight330 } from '../../../../../SharedModules/CommonConstants/commonConstants';
import {
  checkQuarterValidation,
  handleScrollToEvent,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';

const NMFineCode = (props) => {
  const {
    setUpdateNMFinecode,
    fullScreenView,
    setSuccessMessage,
    setDisabledSaveCancelBtn,
    disabledSaveCancelBtn,
    setFullScreenView,
    setErrorMessages,
    isReadOnly,
    isEnabledByRole,
  } = props;
  // dispatch function
  const dispatch = useDispatch();
  const nmFinCodeList = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.nmFinCodes
  );

  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const nmAccInSys = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.nmAccInSys
  );
  const isValidDeleteNMFinCd = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.isValidDeleteNMFinCd
  );
  // variable deceleration
  const gridRef = React.useRef();
  const [gridApi, setGridApi] = React.useState(gridRef);
  const [columnApi, setColumnApi] = React.useState(null);
  const [nmFineCodeGridList, SetNmFineCodeGridList] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteData, setDeleteData] = useState();

  React.useEffect(() => {
    setFullScreenView(false);
    dispatch(dispatchValidateNmFinCd(''));
    if (!(nmFinCodeList?.length > 0)) {
      dispatch(getNMFinCode({}));
    }
  }, []);

  React.useEffect(() => {
    if (disabledSaveCancelBtn) {
      SetNmFineCodeGridList(nmFinCodeList);
    }
  }, [disabledSaveCancelBtn]);

  React.useEffect(() => {
    if (nmFinCodeList && nmFinCodeList.length > 0) {
      SetNmFineCodeGridList(nmFinCodeList);
      setUpdateNMFinecode(nmFinCodeList);
    }
  }, [nmFinCodeList]);
  React.useEffect(() => {
    if (deleteData && isValidDeleteNMFinCd) {
      if (
        !nmFineCodeGridList?.filter((x) => {
          return x.updateRecord || x.deleteRecord;
        })?.length > 0
      ) {
        setDisabledSaveCancelBtn(true);
        dispatch(getNMFinCode({}));
      }
      setSuccessMessage([]);
      handleScrollToEvent();
      const nmFinStartQtr =
        deleteData?.node?.data?.rpcArInterfaceIdVO?.nmFinStartQtr;
      setDeleteData('');
      dispatch(dispatchValidateNmFinCd(''));
      setErrorMessages([`${DELETE_NM_ERR} ${nmFinStartQtr}.`]);
    } else if (isValidDeleteNMFinCd === false && deleteData) {
      setSuccessMessage([]);
      setErrorMessages([]);
      dispatch(dispatchValidateNmFinCd(''));
      setDisabledSaveCancelBtn(false);
      const tempObj = nmFineCodeGridList.map((item) => {
        if (item.id === deleteData?.data?.id) {
          item.deleteRecord = true;
        }
        return item;
      });
      deleteData.api.applyTransaction({
        remove: [deleteData.node?.data],
      });
      SetNmFineCodeGridList(tempObj);
      setUpdateNMFinecode(tempObj);
    }
  }, [isValidDeleteNMFinCd]);
  const onGridReady = React.useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  }, []);

  // handing  full screen view function
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const handleAddNewRow = (e, data, colApi) => {
    setSuccessMessage([]);
    setErrorMessages([]);
    const tempObj = data
      ? [...data]
      : nmFineCodeGridList
      ? [...nmFineCodeGridList]
      : [];
    tempObj.unshift({
      rpcArInterfaceIdVO: {
        nmFinStartQtr: '',
        nmFinBudgetRef: '',
        nmFinClass: '',
      },
      oldNMFinStartQtr: '',
      oldNMFinBudgetRef: '',
      oldNMFinClass: '',
      lastUpdateUserId: logInUser,
      newRecord: true,
      deleteRecord: false,
      updateRecord: false,
      startQtrErr: false,
      nmFinBudgetRefErr: false,
      nmFinClassErr: false,
      id: uuidv4(),
    });
    SetNmFineCodeGridList(tempObj);
    setUpdateNMFinecode(tempObj);
    dispatch(dispatchNMFinCodes(tempObj));
    setDisabledSaveCancelBtn(false);
    if (data) {
      dispatch(dispatchNMFinCodes(tempObj));
      dispatch(setNMAccInSys(!nmAccInSys));
    }
    if (columnApi) {
      columnApi.applyColumnState({
        state: [{ colId: 'rpcArInterfaceIdVO.nmFinStartQtr', sort: 'asc' }],
        defaultState: { sort: null },
      });
    }
    if (colApi) {
      colApi.applyColumnState({
        state: [{ colId: 'rpcArInterfaceIdVO.nmFinStartQtr', sort: 'asc' }],
        defaultState: { sort: null },
      });
    }
  };

  const handleDeleteRow = () => {
    dispatch(dispatchValidateNmFinCd(''));
    if (deleteData?.node?.data?.newRecord) {
      const newObj = [...nmFineCodeGridList];
      if (newObj && newObj.length > 0) {
        const key = newObj.findIndex((item) => {
          return item.id === deleteData?.node?.data.id;
        });
        newObj.splice(key, 1);
        SetNmFineCodeGridList(newObj);
        dispatch(dispatchNMFinCodes(newObj));
      }
    } else if (
      deleteData?.node?.data?.rpcArInterfaceIdVO?.nmFinStartQtr &&
      checkQuarterValidation(
        deleteData?.node?.data?.rpcArInterfaceIdVO?.nmFinStartQtr
      )
    ) {
      dispatch(
        validateNmFinCd(
          deleteData?.node?.data?.rpcArInterfaceIdVO?.nmFinStartQtr
        )
      );
    }
  };
  return (
    <>
      <SaveCancelPopup
        data-testid="handleDelete"
        open={deletePopup}
        title="Delete"
        moduleName="the selected NMFinCode"
        onConfim={() => {
          setDeletePopup(false);
          handleDeleteRow();
          setSuccessMessage([]);
          setErrorMessages([]);
        }}
        onCancel={() => {
          setDeletePopup(false);
        }}
      />
      <div x className="ag-theme-alpine">
        <TableGridWithFeatures
          ref={gridRef}
          onGridReady={onGridReady}
          setGridApi={setGridApi}
          gridHeight={fullScreenView ? '70vh' : tableGridHight330}
          rowData={nmFineCodeGridList || []}
          columnDefs={tableHead}
          data-testid="onEditingStopped"
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          exportFile
          helpMessage=""
          hideColumnsInPdf={['action']}
          singleClickEdit
          suppressCellFocus
          navigateToNextCell={navigateToNextCell}
          fileName="nmFinCode"
          addTxt="Add Fin Code"
          addAction={handleAddNewRow}
          disableAddAction={isReadOnly || !isEnabledByRole}
          enterMovesDown
          onCellFocused={onCellFocused}
          frameworkComponents={{
            ActionCellRender: (cellInfo) => {
              return (
                <DeleteActionRender
                  cellInfo={cellInfo}
                  setDeletePopup={setDeletePopup}
                  setDeleteData={setDeleteData}
                  disabled={isReadOnly || cellInfo?.data.enableFlag || !isEnabledByRole}
                />
              );
            },
            StartQuarterTextBoxRender: (cellInfo) => {
              return (
                <TextBoxRender
                  {...cellInfo}
                  setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
                  disabled={isReadOnly || !isEnabledByRole}
                />
              );
            },
            NMFinBudgetRefTextBoxRender: (cellInfo) => {
              return (
                <TextBoxRender
                  {...cellInfo}
                  setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
                  setUpdateNMFinecode={setUpdateNMFinecode}
                  disabled={isReadOnly || !isEnabledByRole}
                />
              );
            },
            NMFinClassTextBoxRender: (cellInfo) => {
              return (
                <TextBoxRender
                  {...cellInfo}
                  setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
                  disabled={isReadOnly || !isEnabledByRole}
                />
              );
            },
          }}
        />
      </div>
    </>
  );
};
export default withRouter(NMFineCode);
